import React from 'react';

export const ArrowDownIcon = ({ fill='#057A55', width='20', height='20', className='' }) => {
  return (
    
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.10589 13.1486L14.0521 5.21014C14.1628 5.09937 14.2821 5.04859 14.4098 5.05782C14.5374 5.06706 14.6567 5.12706 14.7674 5.23782C14.8782 5.34859 14.9336 5.46987 14.9336 5.60166C14.9336 5.73345 14.8782 5.85473 14.7674 5.9655L6.84895 13.8917H13.7459C13.8932 13.8917 14.0167 13.9411 14.1164 14.04C14.2161 14.1389 14.2659 14.2615 14.2659 14.4077C14.2659 14.5539 14.2161 14.6778 14.1164 14.7793C14.0167 14.8809 13.8932 14.9316 13.7459 14.9316L5.70899 14.9316C5.52679 14.9316 5.37407 14.87 5.25081 14.7468C5.12756 14.6235 5.06593 14.4708 5.06593 14.2886L5.06593 6.25166C5.06593 6.10433 5.11539 5.98083 5.21429 5.88118C5.3132 5.78151 5.43576 5.73168 5.58197 5.73168C5.72819 5.73168 5.85206 5.78151 5.95359 5.88118C6.05513 5.98083 6.10589 6.10433 6.10589 6.25166L6.10589 13.1486Z" fill={fill}/>
    </svg>


    );
};

export default ArrowDownIcon;
